import productsData from "./products.json";

export const API = "";

export const LOGO_URL = "/images/logo.png?v=3";

export const HERO_IMAGE =
  "https://images.pexels.com/photos/33851721/pexels-photo-33851721.jpeg";

export { productsData };
